export var EnquiryPurpose;
(function (EnquiryPurpose) {
    EnquiryPurpose["AppointmentRequest"] = "APPOINTMENT_REQUEST";
    EnquiryPurpose["Insurance"] = "INSURANCE";
    EnquiryPurpose["Investor"] = "INVESTOR";
    EnquiryPurpose["NewPurchase"] = "NEW_PURCHASE";
    EnquiryPurpose["NonMortgageLoan"] = "NON_MORTGAGE_LOAN";
    EnquiryPurpose["Other"] = "OTHER";
    EnquiryPurpose["Refinance"] = "REFINANCE";
    EnquiryPurpose["UrgentCallbackRequest"] = "URGENT_CALLBACK_REQUEST";
})(EnquiryPurpose || (EnquiryPurpose = {}));
//# sourceMappingURL=index.js.map